import { useState, useEffect } from 'react';
import { preload } from 'react-dom';
import { Link } from 'react-router-dom';
import WorkBackground from '../Images/work-background.webp';
import './Navbar.css';

// Start the large hero download when a visitor shows intent to open this page.
const preloadWorkBackground = () => {
  preload(WorkBackground, { as: 'image', fetchPriority: 'high' });
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Prevent body scroll when sidebar is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <>
      <nav className="navbar navbar-transparent">
        <h1 className="navbar-title">Omar Elgazzar</h1>

        {/* Desktop links */}
        <div className="links">
          <Link to="/">Home</Link>
          <Link to="/work-experience" onMouseEnter={preloadWorkBackground} onFocus={preloadWorkBackground} onTouchStart={preloadWorkBackground}>Work Experience</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/bio">Bio</Link>
        </div>

        {/* Hamburger (mobile only) */}
        <button
          className="hamburger"
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isOpen}
          onClick={() => setIsOpen(prev => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* Mobile sidebar (mobile only) */}
      <div className={`mobile-sidebar ${isOpen ? 'open' : ''}`}>
        <nav className="mobile-links" onClick={() => setIsOpen(false)}>
          <Link to="/">Home</Link>
          <Link to="/work-experience" onMouseEnter={preloadWorkBackground} onFocus={preloadWorkBackground} onTouchStart={preloadWorkBackground}>Work Experience</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/bio">Bio</Link>
        </nav>
      </div>

      {/* Overlay for mobile */}
      {isOpen && <div className="nav-overlay" onClick={() => setIsOpen(false)} />}
    </>
  );
};

export default Navbar;
